import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

import { fetchRouting, searchRevisionSummaries } from './functionRevisionUtils';

export function FunctionRevisions() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [revisions, setRevisions] = useState([]);
    const [routing, setRouting] = useState({});

    const reload = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const [routingResult, revisionsResult] = await Promise.all([
                fetchRouting(),
                searchRevisionSummaries(),
            ]);
            if (routingResult.error || revisionsResult.error) {
                setLoading(false);
                setError(routingResult.error || revisionsResult.error);
                return;
            }
            setRouting(routingResult.result);
            setRevisions(revisionsResult.results);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            setError(e.message);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    if (loading) {
        return <div>Loading...</div>;
    }

    const prodVersion = routing.prod && routing.prod.version;
    const devVersion = routing.dev && routing.dev.version;

    return (
        <div style={{ padding: '18px' }}>
            <h1>Lua Function Revisions</h1>
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <table style={{ marginBottom: '24px' }}>
                <tbody>
                    <tr>
                        <td style={{ paddingRight: '12px', fontWeight: 'bold' }}>Production</td>
                        <td style={{ paddingRight: '12px' }}>{prodVersion != null ? `v${prodVersion}` : '(unset)'}</td>
                        <td style={{ paddingRight: '12px' }}>{routing.prod && routing.prod.updated_by}</td>
                        <td>{routing.prod && new Date(routing.prod.updated_at).toLocaleString()}</td>
                    </tr>
                    <tr>
                        <td style={{ paddingRight: '12px', fontWeight: 'bold' }}>Dev</td>
                        <td style={{ paddingRight: '12px' }}>{devVersion != null ? `v${devVersion}` : '(unset)'}</td>
                        <td style={{ paddingRight: '12px' }}>{routing.dev && routing.dev.updated_by}</td>
                        <td>{routing.dev && new Date(routing.dev.updated_at).toLocaleString()}</td>
                    </tr>
                </tbody>
            </table>
            <table className="table" style={{ tableLayout: 'fixed', width: '100%' }}>
                <colgroup>
                    <col style={{ width: '120px' }} />
                    <col />
                    <col style={{ width: '120px' }} />
                    <col style={{ width: '200px' }} />
                    <col style={{ width: '340px' }} />
                </colgroup>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Description</th>
                        <th>Created By</th>
                        <th>Created At</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {revisions.map(revision => (
                        <tr key={revision._id}>
                            <td>
                                {revision._id}
                                {revision._id === prodVersion && <span style={{ marginLeft: '6px', color: 'green' }}>[PROD]</span>}
                                {revision._id === devVersion && <span style={{ marginLeft: '6px', color: 'blue' }}>[DEV]</span>}
                            </td>
                            <td>{revision.description}</td>
                            <td>{revision.created_by}</td>
                            <td>{new Date(revision.created_at).toLocaleString()}</td>
                            <td>
                                <Button size="sm" variant="light" href={`/lua/diff?b=${revision._id}`}>View</Button>
                                {' '}
                                {revision._id !== devVersion &&
                                    <Button size="sm" variant="light" href={`/lua/diff?a=${devVersion != null ? devVersion : ''}&b=${revision._id}&target=dev`}>
                                        Set Dev
                                    </Button>}
                                {' '}
                                {revision._id !== prodVersion &&
                                    <Button size="sm" variant="light" href={`/lua/diff?a=${prodVersion != null ? prodVersion : ''}&b=${revision._id}&target=prod`}>
                                        Set Prod
                                    </Button>}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
